import { render } from "./Suggestions.vue?vue&type=template&id=f1f7a74c&scoped=true&ts=true"
import script from "./Suggestions.ts?vue&type=script&lang=ts&external"
export * from "./Suggestions.ts?vue&type=script&lang=ts&external"

import "./Suggestions.scss?vue&type=style&index=0&id=f1f7a74c&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1f7a74c"]])

export default __exports__